import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { trackEvent } from '../tracking'
import DataGrid from '../components/datagrid/DataGrid';
import { GLO_ADVERTISER } from '../utils/link';

const columns = [
  { id: 'nameHearst', label: 'Name', link: GLO_ADVERTISER },
  { id: 'businessUnit', label: 'Business Unit' },
  { id: 'countryCode', label: 'Country' },
  { id: 'type', label: 'Type' },
  { id: 'idHearst', label: 'Id' }
];

const styles = ( /* theme */ )=> ({
  root: {
    padding: 20
  }
});

class AdvertiserList extends Component {

  getRows = () => {
    const { advertisers } = this.props;
    return advertisers.map(adv => Object.assign({}, adv, {
      businessUnit: adv.BusinessUnit ? adv.BusinessUnit.name : 'none'
    }));
  };

  downloadIOReport = () => {
    trackEvent({
      category: 'advertisers',
      action: 'IO Push Status Re'
    })
    const response = {
      file: `${window.runConfig.REACT_APP_API_URL}/reports/io_push_status?mode=All`
    };
    window.location.href = response.file;
  };

  render() {
    const {
      classes,
      searchQuery,
      onSearch,
      isReadOnly
    } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={10}>
            <Paper className={classes.root}>
              <TextField
                variant="standard"
                label="Search Advertisers"
                fullWidth
                value={searchQuery}
                onChange={onSearch} />
            </Paper>
          </Grid>
          <Grid item xs={2}>
            <Button variant="contained" onClick={this.downloadIOReport} className={classes.button}>
              IO Push Status Report
            </Button>

          </Grid>

          <Grid item xs={12}>
            <DataGrid
              key={searchQuery}
              pagination
              sortable
              columns={columns}
              sortColumn="name"
              data={this.getRows()}
              title="Advertisers"
              showFilterRow={false}
              offsetTop={270}
              isReadOnly={isReadOnly}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

AdvertiserList.propTypes = {
  advertisers: PropTypes.array.isRequired
};

export default withStyles(styles)(AdvertiserList);
